<ng-container *ngIf="show">
    <ng-container [ngSwitch]="alertType">
        <!-- Loading Message -->
        <avi-alert-group
            *ngSwitchCase="'loading'"
            alertType="loading"
        >
            <ng-container *ngrxLet="loadingStatus">
                <span
                    class="logs-errors__alert-text"
                    *ngIf="loadingStatus?.isGraphApiLoopInProgress && loadingStatus?.isTableApiLoopInProgress"
                >
                    {{ loadingMessageLabel }}
                </span>
                <span
                    class="logs-errors__alert-text"
                    *ngIf="loadingStatus?.isGraphApiLoopInProgress && !loadingStatus?.isTableApiLoopInProgress"
                >
                    {{ graphLoadingMessageLabel }}
                </span>
                <span
                    class="logs-errors__alert-text"
                    *ngIf="!loadingStatus?.isGraphApiLoopInProgress && loadingStatus?.isTableApiLoopInProgress"
                >
                    {{ tableLoadingMessageLabel }}
                </span>
            </ng-container>
        </avi-alert-group>

        <!-- Timeout Message -->
        <avi-alert-group
            *ngSwitchCase="'warning'"
            alertType="warning"
            [closable]="closable"
            (onAlertClose)="handleCloseClick()"
        >
            <span class="logs-errors__alert-text">{{ timeoutMessageLabel }}</span>
            <cds-alert-actions *ngIf="learnMoreLinkText || refreshLogsLabelText">
                <cds-button *ngIf="learnMoreLinkText">
                    <a
                        [href]="timeoutsDocLink"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {{ learnMoreLinkText }}
                    </a>
                </cds-button>
                <cds-button
                    *ngIf="refreshLogsLabelText"
                    (click)="handleRefreshClick()"
                >
                    {{ refreshLogsLabelText }}
                </cds-button>
            </cds-alert-actions>
        </avi-alert-group>

        <!-- Info Message -->
        <avi-alert-group
            *ngSwitchCase="'info'"
            alertType="info"
            [size]="size"
            [closable]="closable"
            (onAlertClose)="handleCloseClick()"
        >
            <span class="logs-errors__alert-text">{{ infoMessageLabel }}</span>
        </avi-alert-group>

        <!-- Success Message -->
        <avi-alert-group
            *ngSwitchCase="'success'"
            alertType="success"
            [closable]="closable"
            (onAlertClose)="handleCloseClick()"
        >
            <span class="logs-errors__alert-text">{{ successMessageLabel }}</span>
        </avi-alert-group>

        <!-- Error Message -->
        <avi-alert-group
            *ngSwitchCase="'danger'"
            alertType="danger"
            [closable]="closable"
            (onAlertClose)="handleCloseClick()"
        >
            <span class="logs-errors__alert-text">{{ errorMessage }}</span>
            <cds-alert-actions *ngIf="actionLabel">
                <cds-button (click)="handleActionClick()">
                    {{ actionLabel }}
                </cds-button>
            </cds-alert-actions>
        </avi-alert-group>
    </ng-container>
</ng-container>
